import Modal from './modal';
import Card from '../card/Card';
import P from '../texts/p/P';
import TextArea from '../textarea/TextArea';

export interface DeclineOrRequestChangesModalProps {
  open: boolean;
  onClose: () => void;
  comment: string;
  onCommentChange: (value: string) => void;
  maxLength?: number;
  requireComment?: boolean;
  hideDeclineOption?: boolean;
  onDecline: (comment: string) => void;
  onRequestChanges: (comment: string) => void;
  selectionCount?: number;
}

const DeclineOrRequestChangesModal: React.FC<
  DeclineOrRequestChangesModalProps
> = ({
  open,
  onClose,
  comment,
  onCommentChange,
  maxLength,
  requireComment = true,
  hideDeclineOption = false,
  onDecline,
  onRequestChanges,
  selectionCount = 1,
}) => {
  const trimmed = comment.trim();
  const actionsDisabled = requireComment && trimmed.length === 0;

  const handleDecline = () => {
    if (requireComment && trimmed.length === 0) return;
    onDecline(trimmed);
  };

  const handleRequestChanges = () => {
    if (requireComment && trimmed.length === 0) return;
    onRequestChanges(trimmed);
  };

  const contextNote =
    selectionCount > 1
      ? `Vas a aplicar la acción a ${selectionCount} carpetas seleccionadas.`
      : null;

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title='Declinar o solicitar cambios'
      primaryText='Solicitar cambios'
      primaryVariant='primary'
      primaryActionDisabled={actionsDisabled}
      onPrimaryAction={handleRequestChanges}
      secondaryText={hideDeclineOption ? '' : 'Declinar solicitud'}
      secondaryVariant='secondary'
      secondaryActionDisabled={actionsDisabled}
      onSecondaryAction={hideDeclineOption ? onClose : handleDecline}
    >
      <Card>
        {contextNote && (
          <P type='1' variant='neutral' withMargin>
            {contextNote}
          </P>
        )}
        <P type='1' variant='neutral' withMargin={false}>
          Declinar una solicitud eliminará la documentación.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <P type='1' variant='neutral' withMargin={false}>
          También podés solicitar cambios. Detallalos abajo, y la solicitud
          volverá al productor con ese pedido.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            id='decline-or-request-changes-comment'
            value={comment}
            placeHolder='Escribí los cambios que solicitás, o el motivo de la denegación.'
            maxLength={maxLength}
            maxLengthHelpText={false}
            required={requireComment}
            onChange={(e) => onCommentChange(e.target.value)}
          />
        </Card>
      </Card>
    </Modal>
  );
};

export default DeclineOrRequestChangesModal;
